const jsonUrls = {
    // 首页banner
    homeBanner: 'static/json/homeBanner.json',
    // 五大模块
    scale: 'static/json/scale.json',
    // 交易所导航轮播
    exchangeBanner: 'static/json/exchangeBanner.json',
    // 商业计划
    investorList: 'static/json/investor.json',
    // 全球公益活动
    activityList: 'static/json/activity.json',
    // 孵化规则
    incubateList: 'static/json/rule.json',
    // 交易所导航
    exchangeList: 'static/json/exchange.json',
    // 街道导航静态数据
    streetNavList: 'static/json/street.json',
    // 投资机构
    investmentList: 'static/json/investment.json',
    // 城市数据
    cityList: 'static/json/city.json',
};
export default jsonUrls;


// WEBPACK FOOTER //
// ./src/api/jsonUrl.js